import React from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Label,
  Bar,
  BarChart,
  Legend,
} from 'recharts';
import { formatDuration } from 'src/services/coCustomerAnalyticsService';

export const AnalyticsCustomerBarChartData = ({
  title = '',
  stackTitle = '',
  dataKey = '',
  dataKeyStack = '',
  data = [],
  groupBy = 'day',
}) => {
  const isDayRange = groupBy === 'day';
  const isTimeFormat = ['firstResponseTimeAvg', 'resolutionTimeAvg', 'responseTimeAvg'].includes(
    dataKey,
  );
  let YAxisLabel = isTimeFormat ? 'Min' : 'Tickets';
  YAxisLabel = dataKey === 'resolutionRate' ? '%' : YAxisLabel;
  YAxisLabel = ['aiRepliesSent', 'aiRepliesPerProcessedTicket'].includes(dataKey)
    ? 'Replies'
    : YAxisLabel;

  const tooltipFormatter = (value) => {
    if (isTimeFormat) {
      return value ? formatDuration(value, 'minutes') : 0;
    }

    return `${value} ${YAxisLabel}`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={'550px'}>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 32,
          right: 70,
          left: 10,
          bottom: 15,
        }}
      >
        <CartesianGrid vertical={false} strokeDasharray="1 1" />
        <XAxis
          tickFormatter={(value) => {
            if (typeof value === 'string' && value.includes(':')) {
              return value.replace(':00', '').replace(/^0/, '');
            }
            return value;
          }}
          axisLine={{ stroke: '#DFE3E8' }}
          tickLine={false}
          dataKey="formattedGroup"
          tick={{
            fontSize: 11,
            fontFamily: 'Bai Jamjuree',
            fontWeight: 500,
            opacity: 0.3,
            dy: 7,
          }}
        >
          <Label
            value={isDayRange ? 'Days' : 'Hours'}
            position="right"
            dy={-15}
            dx={10}
            className={'fill-ebony text-sm font-semibold'}
          />
        </XAxis>
        <YAxis
          tick={{
            fontSize: 11,
            fontFamily: 'Bai Jamjuree',
            fontWeight: 500,
            opacity: 0.3,
            dx: -7,
          }}
          axisLine={{ stroke: '#DFE3E8' }}
          tickLine={false}
          allowDecimals={false}
        >
          <Label
            value={YAxisLabel}
            dy={-12}
            dx={25}
            position="top"
            className={'fill-ebony text-sm font-semibold'}
          />
        </YAxis>
        <Tooltip
          formatter={tooltipFormatter}
          labelStyle={{
            color: '#05050D',
            fontFamily: 'Bai Jamjuree',
            fontSize: '12px',
            opacity: 0.5,
          }}
          contentStyle={{
            borderRadius: '5px',
            background: '#FFF',
          }}
          itemStyle={{
            fontFamily: 'Bai Jamjuree',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 600,
          }}
        />
        {Boolean(data.length) && (
          <ReferenceLine
            x={data[parseInt((data.length / 2).toFixed(0)) - 1]['formattedGroup']}
            stroke="#CCCCCC"
            strokeDasharray="1 1"
          />
        )}
        <Legend
          verticalAlign="top"
          align="left"
          iconType={'circle'}
          iconSize={8}
          labelStyle={{ fontSize: '0.75rem', color: '#DFDFE8' }}
          wrapperStyle={{ marginLeft: '100px' }}
          height={36}
        />
        <Bar name={title} dataKey={dataKey} stackId="a" fill="#5D4EC7" maxBarSize={34} />
        {dataKeyStack && (
          <Bar
            name={stackTitle}
            dataKey={dataKeyStack}
            stackId="a"
            fill="#E1DCFF"
            maxBarSize={34}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};
